import { render, staticRenderFns } from "./AdvertisementCard.vue?vue&type=template&id=2f412e76&scoped=true"
import script from "./AdvertisementCard.vue?vue&type=script&lang=js"
export * from "./AdvertisementCard.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementCard.vue?vue&type=style&index=0&id=2f412e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f412e76",
  null
  
)

export default component.exports